import { render, staticRenderFns } from "./AccordionBase.vue?vue&type=template&id=1f2bf3cb&scoped=true"
import script from "./AccordionBase.vue?vue&type=script&lang=js"
export * from "./AccordionBase.vue?vue&type=script&lang=js"
import style0 from "./AccordionBase.vue?vue&type=style&index=0&id=1f2bf3cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2bf3cb",
  null
  
)

export default component.exports